export default __webpack_public_path__ + "static/media/payment-success.a266c26c.svg";